<script>
import { computed, ref } from '@vue/reactivity'
import { useStore } from 'vuex'
import Slider from '~/pages/configurator/common/slider'
import SelectOption from './option/selectOption'
import CountOption from './option/countOption'

export default {
  name: 'Simpleselect',
  components: {
    Slider,
    selectOption: SelectOption,
    countOption: CountOption,
    checkOption: SelectOption
  },
  setup () {
    const store = useStore()
    const category = ref(null)
    const showAll = ref(false)
    const componentKey = ref(0)
    const page = ref(1)
    const perPage = ref(6)

    const step = computed(() => {
      return store.getters['system/currentStep']
    })
    const currentOptions = computed(() => {
      return store.getters['system/currentOptions']
    })
    const categories = computed(() => {
      if (step.value.categories) {
        return step.value.categories
      }
    })
    const options = computed(() => {
      const list = currentOptions.value || []
      if (category.value !== null) {
        return list.filter(o => o.category && o.category.some(c => String(c) === String(category.value)))
      }
      return list
    })
    const startPage = computed(() => {
      const list = options.value
      const index = list.findIndex(o => o.selected)
      if (index === -1) {
        return 1
      }
      const pageNum = Math.ceil((index + 1) / perPage.value)
      return pageNum || 1
    })
    // methods
    function setCategory (catId) {
      category.value = catId
      const selected = categories.value.find(c => c.selected)
      const cat = categories.value.find(c => c.id === catId)
      cat.selected = !cat.selected
      if (!cat.selected) {
        category.value = null
      }
      if (typeof selected !== 'undefined') {
        selected.selected = false
      }
      componentKey.value += 1
    }
    function showAllModel () {
      showAll.value = !showAll.value
    }
    return {
      category,
      showAll,
      componentKey,
      page,
      perPage,
      step,
      categories,
      startPage,
      options,
      setCategory,
      showAllModel
    }
  }
}
</script>
<template>
    <h3 class="heading-title" v-if="step.name === 'Muster'">Wählen Sie jetzt das Muster für Ihre Zaunanlage.</h3>
    <h3 class="heading-title" v-if="step.name === 'Form'">Wählen Sie jetzt die Verlaufsform aus.</h3>
    <h3 v-if="step.description && step.name !== 'Muster' && step.name !== 'Form'" class="step-description">{{ step.description }}</h3>
<!--    <div class="mb-4" v-if="step.name == 'Muster'">-->
<!--      <button class="btn" :class="{ 'btn-warning': showAll, 'btn-outline-warning': !showAll }" @click="showAllModel">-->
<!--        <span v-if="!showAll">Alle Muster anzeigen</span>-->
<!--        <span v-else-if="showAll">Alle Muster verbergen</span>-->
<!--      </button>-->
<!--    </div>-->
<!--    <div v-if="showAll" class="row">-->
<!--      <div v-for="option in options" :key="option.id" class="col-2 mb-4">-->
<!--        <component :is="(option.type || 'select') + 'Option'" :key="option.id" :option="option" />-->
<!--      </div>-->
<!--    </div>-->
  <Slider v-if="!showAll"
          ref="slider"
          class="equal-cards"
          :itemClass="step.css"
          :init-page="startPage"
          :item-count="options.length"
          chevron="true"
          :key="componentKey">

    <component v-for="option in options"
               :is="(option.type || 'select') + 'Option'"
               :key="option.id"
               :option="option"
               :type="step.css" />
  </Slider>

</template>
<style scoped>
.equal-cards :deep(.row.options > div) {
  display: flex;
}
</style>
